import { Order } from "@/api/orders.api";
import { useTranslation } from "react-i18next";
import { CheckCircle2 } from "lucide-react";

interface OrderPosDetailsProps {
  order: Pick<Order, "checkNumber" | "posPaymentPosted">;
}

/**
 * POS-side details shown under an order's Mezza identifier: the POS check number (Toast venues) and, for
 * Toast - Integrated venues only, whether Mezza posted the payment onto the check itself. Renders nothing
 * for venues without either, so non-Toast cards are unchanged.
 */
export function OrderPosDetails({ order }: OrderPosDetailsProps) {
  const { t } = useTranslation();

  return (
    <>
      {order.checkNumber && (
        <div className="text-xs text-muted-foreground tabular-nums whitespace-nowrap">
          {t("orders.checkNumber")} #{order.checkNumber}
        </div>
      )}

      {order.posPaymentPosted === true && (
        <div className="text-xs text-emerald-600 tabular-nums whitespace-nowrap flex items-center gap-1">
          <CheckCircle2 className="h-3 w-3" aria-hidden="true" />
          {t("orders.posPaymentPosted")}
        </div>
      )}

      {order.posPaymentPosted === false && (
        <div className="text-xs text-amber-600 tabular-nums whitespace-nowrap">
          {t("orders.posPaymentUnverified")}
        </div>
      )}
    </>
  );
}
